
import { Component, Vue, Model, Prop, Emit } from 'vue-property-decorator';

@Component
export default class Parts extends Vue {
  @Model('change', { type: [Boolean, Array], required: true })
  public checked!: boolean | string[];

  @Prop({ type: String, required: false })
  public name!: string | undefined;

  @Prop({ type: String, required: false })
  public value!: string | undefined;

  @Prop({ type: Boolean, default: true })
  public enabled!: boolean;

  @Emit('change')
  private change(value: boolean | string[]) {}

  private get localValue(): boolean | string[] {
    return this.checked;
  }

  private set localValue(value: boolean | string[]) {
    this.change(value);
  }

  private get isChecked(): boolean {
    if (typeof this.checked === 'boolean') {
      return this.checked;
    } else if (typeof this.value === 'string') {
      return this.checked.indexOf(this.value) >= 0;
    } else {
      return false;
    }
  }
}
